import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	name: Yup.string().required().label('Country name'),

});
const Inputs = [

	{
		name: 'name',
		label: 'Name',
		type: 'text',
		value: 'single',
		valueAttr: 'name',
	},
	{
		name: 'iso2',
		label: 'ISO2 Country Code',
		type: 'text',
		value: 'single',
		// Reads the existing code from the GET response (`countryCode`),
		// but submits it back to the API as `iso2` (UpdateCountryDTO.Iso2).
		valueAttr: 'countryCode',
		nameForDb: 'iso2',
	},
	{
		name: 'leagueIds',
		label: 'Top Leagues',
		type: 'select',
		value: 'multiple',
		valueAttr: 'leagueIds',
		enableOrder: true,
	},
	{
		name: 'translations',
		label: 'Translations',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'translations',
		columns: [
			{
				name: 'languageCode',
				label: 'Language',
				type: 'text',
				required: true,
			},
			{
				name: 'translatedName',
				label: 'Translated Name',
				type: 'text',
				required: true,
			}
		]
	},
	{
		name: 'externalLink',
		label: 'External Link URL',
		type: 'text',
		value: 'single',
		valueAttr: 'externalLink',
	},
	{
		name: 'externalLinkTitle',
		label: 'External Link Title',
		type: 'text',
		value: 'single',
		valueAttr: 'externalLinkTitle',
	},
	{
		name: 'externalLinkDescription',
		label: 'External Link Description',
		type: 'textarea',
		value: 'single',
		valueAttr: 'externalLinkDescription',
	},
	{
		name: 'externalLinkImage',
		label: 'External Link Image',
		type: 'image',
		value: 'single',
		valueAttr: 'externalLinkImagePath',
		required: false,
		defaultValue: '',
		onChange: (localValues: any, event: any) => {
			const file = event.target.files?.[0];
			if (!file) return;
			localValues['externalLinkImage'] = file;
			localValues['externalLinkImagePath'] = URL.createObjectURL(file);
		},
		clearImage: (localValues: any) => {
			const el = document.getElementById('externalLinkImage') as HTMLInputElement | null;
			if (el) el.value = '';
			localValues['externalLinkImage'] = '';
			localValues['externalLinkImagePath'] = '';
		},
		transform: (path: string) => {
			if (!path) return '';
			const safePath = path.replace(' ', '%20');
			if (path?.includes?.('blob')) return safePath;
			return process.env.VUE_APP_ASSETS_URL + '/' + safePath;
		},
	}
];

export { Inputs, validationSchema };
